import { getAppConfig } from '../../../common/config/app-config';
import { httpGetJSON } from '../../../common/services/ajax-services';

const { encodedContextPath } = getAppConfig();

export function getTabDetails(tabs, selectedTab) {
  if (!tabs || !selectedTab) return false;
  return tabs?.filter(tab => tab?.uid === selectedTab);
}
export async function getPreorderProductDetails(productCode) {
  const url = `${encodedContextPath}/pl/preorder/${productCode}`;
  const response = await httpGetJSON(url, {}, {}, true);
  return response;
}
